function Footer() {
  return (
    <section className="relative isolate overflow-hidden w-full flex items-center justify-center">
      <div className="relative mt-10 pt-20 pb-6 w-full px-4 sm:px-10 md:px-20">
        <div className="w-full flex justify-center">
          <p className="text-neutral-600 text-center text-sm sm:text-md 2xl:text-lg font-medium font-quicksand">
            Designed & Developed by <span className="text-carnation">Sara Maenza</span>
          </p>
        </div>
      </div>
    </section>
  )
}

export default Footer;